import { Grid, styled } from "@mui/material";
import { FormApi } from "final-form";
import { Field } from "react-final-form";
import TextFieldControlSimple from "../../../components/FormComponents/TextField.component";

const items = [
  "Waterfall",
  "Mountain",
  "Jungle",
  "Moor",
  "Cave",
  "Herbs",
  "Coast",
  "Hillock",
  "Glacier",
  "Forest",
  "Valley",
  "River/Stream",
  "Lake",
  "Plain",
  "Cliff",
  "Cacti",
  "Flowers",
  "Forageable plants",
  "Wildlife",
  "Medicinal plants",
  "Basin",
  "Aquatic life",
  "Home gardens",
  "Botanic gardens",
  "Regenerative lands",
  "Arboretums",
  "Water spring",
  "Plantation",
  "Urban/Industrial",
  "Lagoon",
  "Minerals",
  "Annual croplands",
  "Pasture",
  "Canyon",
  "Beach",
  "Island",
];

type SelectItemsInputProps = {
  name: "biomes";
  onChange: (name: "biomes", value: any) => void;
  values: any;
  initial?: string[];
  form?: FormApi<any>;
  showDirty?: boolean;
  disabled?: boolean;
};

const SelectItemsInput = ({ disabled, showDirty, initial, name, onChange, values, form }: SelectItemsInputProps) => {
  const handleChooseItem = (item: string) => {
    const map = new Map(
      values
        .split(",")
        .map((item: any) => [item, item])
        .sort((a: any, b: any) => a - b)
    );

    const remove = map.has(item);
    if (remove) {
      map.delete(item);
      onChange(
        name,
        Array.from(map.keys())
          .filter((item) => !!item)
          .join(",")
      );
    } else {
      map.set(item, item);
      onChange(
        name,
        Array.from(map.keys())
          .filter((item) => !!item)
          .join(",")
      );
    }
  };

  const isSelected = (item: string) => values.includes(item);
  const isChanged = (item: string) => (initial ? initial.includes(item) : false);
  const shouldMark = (item: string) => (isChanged(item) && !isSelected(item)) || (!isChanged(item) && isSelected(item));

  let changed = false;
  items.forEach((item) => {
    if (shouldMark(item)) {
      changed = true;
    }
  });

  if (changed && form) {
    // console.log(form.getState());
  }

  return (
    <Container container sx={{ gap: { xs: "18px", md: "24px" } }}>
      <Field disabled={disabled} style={{ display: "none" }} name={name} component={TextFieldControlSimple} />
      {items.map((item, index) => (
        <Item
          className={isSelected(item) ? "SelectItemActive" : ""}
          classes={{
            root: disabled ? "SelectItemDisabled" : "",
          }}
          container
          key={index}
          item
          sx={{
            width: "100%",
            border: "var(--border)",
            borderColor: showDirty ? (shouldMark(item) ? "orange" : "#3d3d3d") : "#3d3d3d",
            padding: 6,
            borderRadius: "16px",
            display: "flex",
            alignContent: "center",
            textTransform: "uppercase",
            fontFamily: "monospace",
          }}
          onClick={() => handleChooseItem(item)}
        >
          {item}
        </Item>
      ))}
    </Container>
  );
};

const Container = styled(Grid)`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  @media (max-width: 560px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

const Item = styled(Grid)`
  cursor: pointer;
  font-size: 16px;
  padding: 12px;
  border-radius: 16px;
  height: 56px;

  @media (max-width: 560px) {
    width: auto;
    min-width: calc(50% - 3px);
  }

  @media (max-width: 425px) {
    min-width: auto;
    padding: 12px 24px;
    font-size: 12px;
  }

  &:hover {
    background: ${({ theme }) => theme.palette.background.paper};
  }

  &.SelectItemActive {
    background: ${({ theme }) => theme.palette.text.primary};
    color: ${({ theme }) => theme.palette.text.secondary};
  }

  &.SelectItemDisabled {
    cursor: default;
    pointer-events: none;
    border-color: ${({ theme }) => theme.palette.divider};
  }

  &.SelectItemDisabled.SelectItemActive {
    background: ${({ theme }) => theme.palette.text.disabled};
  }
`;

export default SelectItemsInput;
